<template>
    <div>
        <b-alert variant="success" :show="isSuccess">
            You now have a free membership until {{ freeUntil }}.
        </b-alert>
        
        <b-alert variant="danger" :show="hasError">
            {{ error }}
        </b-alert>

        <div v-if="numSelected > 0">
            <p>
                You have selected {{ numSelected }} referrals to redeem.
                <span v-if="!hasDoneInitialRedemptionComp && numSelected < 3">
                    You must have at least 3 referrals before you can redeem a free membership.
                </span>
            </p>

            <p v-if="(!hasDoneInitialRedemptionComp && numSelected >= 3) || hasDoneInitialRedemptionComp">
                <button 
                    type="button" 
                    @click="initRedeem" 
                    class="btn btn-success"
                    :disabled="isBusy">
                    Redeem {{ numSelected }} free months of membership
                </button>
            </p>
        </div>

        <div class="referral-redemptions-table">
            <b-table 
                ref="table"
                bordered 
                striped 
                hover 
                :items="referrals" 
                :fields="fields" 
                :busy="isBusy" 
                :tbody-tr-class="rowClass"
                primary-key="id">
                <template v-slot:cell(isReferralRedeemed)="data">
                    <template v-if="data.item.isReferralRedeemed == true">
                        <span class="badge badge-success">Redeemed</span>
                    </template>
                    <template v-else>
                        <button type="button" class="btn btn-sm btn-primary" @click="markSelected(data.index)" :class="{ 'btn-ghost' : data.item.isSelected }">
                            {{ data.item.isSelected ? 'Selected' : 'Redeem' }}
                        </button>
                    </template>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            userId: {
                type: Number,
                default: null
            },
            hasDoneInitialRedemption: {
                type: Boolean,
                default: false,
                required: true
            },
        },

        data() {
            return {
                isBusy: true,
                isSuccess: false,
                freeUntil: '',
                error: '',
                hasError: false,
                referrals: [],
                hasDoneInitialRedemptionComp: false,
                fields: [
                    {
                        key: 'name',
                        label: 'Who',
                        sortable: true
                    },
                    {
                        key: 'email',
                        label: 'Email',
                        sortable: true
                    },
                    {
                        key: 'createdAtDateFormatted',
                        label: 'When they registered',
                        sortable: true
                    },
                    {
                        key: 'isReferralRedeemed',
                        label: 'Redeem',
                        sortable: false
                    },
                ],
                selected: {},
                numSelected: 0,
            }
        },

        mounted() {
            this.getReferrals();

            this.hasDoneInitialRedemptionComp = this.hasDoneInitialRedemption;
        },

        methods: {
            // Get the payments
            getReferrals: function() {
                axios.get('/api/user/' + this.userId + '/referrals')
                    .then((response) => {
                        this.numSelected = 0;
                        this.selected = {};

                        this.referrals = response.data;

                        // Mark all referrals as not being selected
                        this.referrals.map((r) => { r.isSelected = false; });

                        this.isBusy = false;
                    });
            },

            // Mark an item as selected
            markSelected: function(index) {
                this.isSuccess = false; // Reset in case someone reclicks

                // Not selected, add it
                if(!this.referrals[index].isSelected) {
                    this.selected[index] = {
                        'id' : this.referrals[index].id, 
                        'email' : this.referrals[index].email
                    };
                } else {
                    delete this.selected[index];
                }

                this.numSelected = Object.keys(this.selected).length;

                this.referrals[index].isSelected = !this.referrals[index].isSelected;
                this.$refs.table.refresh();
            },

            // Run the redemption
            initRedeem: function() {
                this.isBusy = true;

                axios.post('/api/user/' + this.userId + '/referrals/redeem', {selected: this.selected})
                    .then((response) => {
                        if(response.data.success) {
                            this.getReferrals();
                            this.isSuccess = true;
                            this.freeUntil = response.data.freeUntil;
                            this.hasDoneInitialRedemptionComp = response.data.hasDoneInitialRedemption;
                        }

                        if(response.data.error) {
                            this.hasError = true;
                            this.error = response.data.error;
                        }

                        this.isBusy = false;
                    });
            },
            
            // Colour rows
            rowClass(item, type) {
                if (!item || type !== 'row') return
                if (item.isReferralRedeemed == true) return 'table-success'
            }
        }
    }
</script>
